module.exports = __webpack_public_path__ + "static/media/nextArrow.14ae09f3.svg";